/**
 *
 * @version 12.4.0 #756 MLIBJS-121 Export wd-fiters as a node module
 *
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2020 Build Centrix
 *
 */

var wdCustomFilters = require('./wdCustomFilters');
var wdDateTimeFilters = require('./wdDateTimeFilters');

module.exports = {
    wdCustomFilters: wdCustomFilters.name,
    wdDateTimeFilters: wdDateTimeFilters.name
};

// EOF